import React from 'react';

const CheckInCircleIcon = ({ size = 13 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    aria-hidden="true"
  >
    <path
      d="M6.15088 12.3018C2.78662 12.3018 0 9.51514 0 6.15088C0 2.78662 2.78662 0 6.14453 0C9.50879 0 12.3018 2.78662 12.3018 6.15088C12.3018 9.51514 9.51514 12.3018 6.15088 12.3018ZM6.15088 11.2163C8.96289 11.2163 11.2163 8.96289 11.2163 6.15088C11.2163 3.33887 8.95654 1.08545 6.14453 1.08545C3.33887 1.08545 1.09814 3.33887 1.09814 6.15088C1.09814 8.96289 3.34521 11.2163 6.15088 11.2163ZM5.49707 9.00098C5.2876 9.00098 5.12891 8.91846 4.97021 8.71533L3.52295 6.93799C3.42773 6.82373 3.37695 6.69043 3.37695 6.55713C3.37695 6.27783 3.58643 6.06201 3.85938 6.06201C4.03076 6.06201 4.17041 6.11279 4.31006 6.30322L5.47168 7.80127L7.92822 3.86572C8.04248 3.68164 8.19482 3.58643 8.35986 3.58643C8.62012 3.58643 8.86768 3.76416 8.86768 4.04346C8.86768 4.17676 8.7915 4.31641 8.72168 4.43701L5.99219 8.71533C5.87158 8.89941 5.7002 9.00098 5.49707 9.00098Z"
      fill="#30D158"
    />
  </svg>
);

export default CheckInCircleIcon;
